var KBResults = React.createClass({
    propTypes: {
        searchResults: React.PropTypes.object.isRequired,
        filterData: React.PropTypes.object.isRequired,
        eventHandler: React.PropTypes.func.isRequired,
        showCollectionFilter: React.PropTypes.bool,
        showAttributeFilter: React.PropTypes.bool,
        onEmailClicked: React.PropTypes.func.isRequired,
        onPreviewClicked: React.PropTypes.func.isRequired,
        directView: React.PropTypes.bool
    },
    pageClicked(num) {
        this.props.eventHandler({actionType: 'pageClicked', num: num});
    },
    sortChanged(sortKey, index) {
        this.props.eventHandler({actionType: 'sortChanged', sortKey: sortKey});
    },
    searchCriteriaChanged(searchCriteriaKey, index) {
        this.props.eventHandler({actionType: 'searchCriteriaChanged', searchCriteriaKey: searchCriteriaKey});
    },
    attributeSetChanged(setName) {
        this.props.eventHandler({actionType: 'attributeSetChanged', setName: setName});
    },
    attributesChanged(setName, attributes) {
        this.props.eventHandler({
            actionType: 'attributesChanged', setName: setName,
            attributes: attributes
        });
    },
    collectionsChanged(collections) {
        this.props.eventHandler({actionType: 'collectionsChanged', collections: collections});
    }, favoriteChanged(favorite) {
        this.props.eventHandler({actionType: 'favoriteChanged', favorite: favorite});
    },
    typesChanged(types) {
        this.props.eventHandler({actionType: 'typesChanged', types: types});
    },
    categoryChanged(taxPath) {
        this.props.eventHandler({actionType: 'categoryChanged', taxPath: taxPath});
    },
    dateChanged(startDate, endDate) {
        this.props.eventHandler({
            actionType: 'dateChanged', startDate: startDate,
            endDate: endDate
        });
    },
    languageChanged(lang) {
        this.props.eventHandler({actionType: 'languageChanged', language: lang});
    },
    resetFiltersClicked() {
        this.props.eventHandler({actionType: 'resetFilters'});
    },
    findSelectedSortIndex() {
        let {
            searchResults,
            filterData
        } = this.props;
        let querySortBy = searchResults.query.sortBy.toLowerCase();
        let queryDescending = searchResults.query.sortDescending;

        for (let i = 0; i < filterData.sortKeys.length; i++) {
            let sortKey = filterData.sortKeys[i];
            let thisSortBy = sortKey.key.toLowerCase();
            let thisDescending = sortKey.descending;

            if (thisDescending == undefined) thisDescending = true;

            if (thisSortBy == querySortBy && thisDescending == queryDescending) {
                return i;
            }
        }

        return 0;
    },

    findSelectedSearchCriteriaIndex() {
        let {
            searchResults,
            filterData
        } = this.props;

        const neuralSearchEnabled = searchResults.query.neuralSearchEnabled;
        if (!neuralSearchEnabled) {
            return -1;
        }

        let querySearchCriteria = searchResults.query.searchCriteria.toLowerCase();

        for (let i = 0; i < filterData.searchCriteriaKeys.length; i++) {
            let searchCriteriaKey = filterData.searchCriteriaKeys[i];
            let thisSearchCriteria = searchCriteriaKey.key.toLowerCase();

            if (thisSearchCriteria === querySearchCriteria) {
                return i;
            }
        }

        return 0;
    },
    paramToArray(paramName) {
        let val = RA.KBSearch.query[paramName];
        return typeof val == "string" ? val.split(";") : [];
    },
    getParam(paramName) {
        return RA.KBSearch.query[paramName];
    },
    getPager() {
        let searchResults = this.props.searchResults;
        let pagerDetail = searchResults.pagerDetail;
        return searchResults.totalHits > 0 && pagerDetail.totalPages > 1 ?
            <ResultsPager pagerDetail={pagerDetail} onPageClicked={this.pageClicked}/> : null;
    },
    autoClicked() {
        let hit = this.props.searchResults.results[0];
        let positionParams = `&page=${hit.page}&position=${hit.position}&linw=true&q=` + encodeURIComponent(RA.KBSearch.query.querytext);

        let ticketId = "";
        if (Config.copyToIncidentEnabled) {
            ticketId = `&ticketid=` + $("#ticketID").val();
        }

        let url = `${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${hit.solution.id}${positionParams}${ticketId}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
        window.open(url);
    },
    showAICHat() {
        const showAIChat = RA.KBSearch.query.querytext && RA.KBSearch.query.querytext.trim().replace(/\s+/gi, " ").split(" ").length > 1;
        const preventChatTrigger = this.props.searchResults.preventChatTrigger;
        return RA.KBSearch.isAiChatEnabled() && showAIChat && !preventChatTrigger;
    },
    getResultsSection() {
        let {filterData, searchResults} = this.props;
        let didYouMean = searchResults.didYouMean;

        return (
            <div>
                <div className="result-col__head clearfix">
                    {this.showAICHat() ? <AIChat query={RA.KBSearch.query.querytext}/> : null}
                    <ResultCountSummary 
                        totalHits={searchResults.totalHits}
                        pageStart={searchResults.pagerDetail.pageStart}
                        pageEnd={searchResults.pagerDetail.pageEnd}
                    />
                    <div className="result-col__head-right">
                        <ResultSearchCriteria 
                            searchCriteriaKeys={filterData.searchCriteriaKeys}
                            selectedIndex={this.findSelectedSearchCriteriaIndex()}
                            onSearchCriteriaChanged={this.searchCriteriaChanged} 
                        />
                        <ResultSort sortKeys={filterData.sortKeys}
                            selectedIndex={this.findSelectedSortIndex()}
                            onSortChanged={this.sortChanged} 
                        />
                    </div>
                </div>
                <KBDidYouMean didYouMean={didYouMean}/>
                <KBResultsList hits={searchResults.results} onEmailClicked={this.props.onEmailClicked}
                               onSolClicked={(searchResults.results.length == 1 && Config.viewOneSolutionResult && this.props.directView) ? this.autoClicked() : this.props.onSolClicked}
                               onPreviewClicked={this.props.onPreviewClicked}/>
                {this.getPager()}
            </div>
        )
    },
    getEmptyResultSection: function (filterData) {
        return <div>
            <div className="result-col__head-right">
                <ResultSearchCriteria
                    searchCriteriaKeys={filterData.searchCriteriaKeys}
                    selectedIndex={this.findSelectedSearchCriteriaIndex()}
                    onSearchCriteriaChanged={this.searchCriteriaChanged}
                />
            </div>
            <NoResults showResetFilters={RA.KBSearch.isFilterApplied()} onFilterResetClicked={this.resetFiltersClicked}/>
        </div>;
    },
    render() {
        let {filterData, searchResults} = this.props;
        let didYouMean = searchResults.didYouMean;
        let pauseSolutionAutoView = localStorage.getItem('pauseSolutionAutoView');
        this.props.directView = ((searchResults.totalHits == 1) && pauseSolutionAutoView !== 'true');

        let hitsCount = searchResults.totalHits === 0;
        let resultsContent = hitsCount ? this.getEmptyResultSection(filterData) : this.getResultsSection();

        let noResultDymSection = hitsCount ? <KBDidYouMean didYouMean={didYouMean}/> : '';

        return (
            <div className="row">
                <ResponsiveFilterColumn className="col-xs-12 col-sm-3 filter-col">
                    <FavoriteFilter showFavoriteFilter={this.props.showFavoriteFilter}
                                    favoritesOnly={this.getParam("favoritesOnly")}
                                    onFavoriteChanged={this.favoriteChanged}/>
                    <CategoryFilter categories={searchResults.browsePaths}
                                    currentPath={RA.KBSearch.query.taxlevelValue}
                                    onCategoryChanged={this.categoryChanged}/>
                    <AttributeFilter showAttributeFilter={this.props.showAttributeFilter}
                                     attributeSets={searchResults.attributeSets}
                                     attributes={searchResults.attributes}
                                     selectedSetName={RA.KBSearch.query.attributesetname}
                                     selectedAttributeKeys={this.paramToArray("attributes")}
                                     onAttributeSetChanged={this.attributeSetChanged}
                                     onAttributesChanged={this.attributesChanged}/>
                    <DateFilter searchDates={this.props.filterData.searchDates}
                                selectedStartDate={RA.KBSearch.query.advstartdate}
                                onDateChanged={this.dateChanged}/>
                    <CollectionFilter showCollectionFilter={this.props.showCollectionFilter}
                                      customCollections={this.props.filterData.customCollections}
                                      selectedCollections={this.paramToArray("searchaliases")}
                                      onCollectionsChanged={this.collectionsChanged}/>
                    <TypeFilter defaultTypes={this.props.filterData.defaultTypes}
                                selectedTypes={this.paramToArray("advkeywords")}
                                onTypesChanged={this.typesChanged}
                    />
                    <LanguageFilter searchLanguages={this.props.filterData.searchLanguages}
                                    selectedLanguage={searchResults.query.selectedLanguages[0]}
                                    onLanguageChanged={this.languageChanged}/>
                </ResponsiveFilterColumn>
                <section className="col-xs-12 col-sm-9 result-col" role="region" aria-label={Labels.getLabel("Results")}
                         title={Labels.getLabel("Results")}>
                    {resultsContent}
                    {noResultDymSection}
                </section>
            </div>
        )
    }
})